const i18n = JSON.parse(document.querySelector('#accessibility [data-translations]').innerText);

document.querySelector('#accessibility button').addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    document.body.classList.toggle('high-contrast');
    if (window.localStorage) {
        if (document.body.classList.contains('high-contrast')) {
            window.localStorage.setItem('high-contrast', 'true');
            document.body.classList.add('high-contrast');
            document.body.setAttribute('data-contrast', 'high');
            document.querySelector('#accessibility button').setAttribute('title', i18n.highContrastOff_Label);
            document.querySelector('#accessibility button').setAttribute('aria-label', i18n.highContrastOff_Label);
            document.querySelector('#accessibility button').setAttribute('data-ats-accessibility-button', 'on');
        } else {
            window.localStorage.removeItem('high-contrast');
            document.body.classList.remove('high-contrast');
            document.body.removeAttribute('data-contrast');
            document.querySelector('#accessibility button').setAttribute('title', i18n.highContrastOn_Label);
            document.querySelector('#accessibility button').setAttribute('aria-label', i18n.highContrastOn_Label);
            document.querySelector('#accessibility button').setAttribute('data-ats-accessibility-button', 'off');
        }
    }
});
if (window.localStorage && window.localStorage.getItem('high-contrast') === 'true') {
    document.body.classList.add('high-contrast');
    document.querySelector('#accessibility button').setAttribute('title', i18n.highContrastOff_Label);
    document.querySelector('#accessibility button').setAttribute('aria-label', i18n.highContrastOff_Label);
    document.querySelector('#accessibility button').setAttribute('data-ats-accessibility-button', 'on');
}
